import { testimonials } from '@/mocks/homepage';

export default function TestimonialsSection() {
  return (
    <section className="w-full px-6 md:px-10 py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-sm font-semibold text-secondary-600 bg-secondary-100 px-4 py-1.5 rounded-full mb-4">
            用户口碑
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            听听用户怎么说
          </h2>
          <p className="text-foreground-600 text-base max-w-2xl mx-auto">
            来自各行各业的团队都在使用一起草提升协作效率
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="p-6 rounded-lg bg-background-100/70 border border-background-200/60"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={testimonial.avatar}
                  alt={testimonial.name}
                  className="w-10 h-10 rounded-full object-cover"
                  width={40}
                  height={40}
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{testimonial.name}</div>
                  <div className="text-xs text-foreground-500">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}